<div [ngClass]="styles.container">
	<div [ngClass]="styles.itemRow">
		<span>{{ 'Device_VideoSource' | translate }}:</span>
		<span>&nbsp;{{ selectedVideoSource.label }}</span>
	</div>
	<div [ngClass]="styles.itemRow">
		<span>{{ 'Media_Autoplay' | translate }}:</span>
		<span>&nbsp;{{ (webcast.autoplay ? 'UI_Enabled' : 'UI_Disabled') | translate }}</span>
	</div>

	<div [ngClass]="styles.itemRow">
		<span>{{ 'Event_AutomatedWebcast' | translate }}:</span>
		<span>&nbsp;{{ (webcast.automatedWebcast ? 'UI_Enabled' : 'UI_Disabled') | translate }}</span>
	</div>
	<div [ngClass]="styles.itemGroup">
		<div [ngClass]="styles.itemRow">
			<span>{{ 'Event_LiveEventSubtitles' | translate }}:</span>
			<span>&nbsp;{{ (webcast.liveSubtitles?.isLiveSubtitlesEnabled ? 'UI_Enabled' : 'UI_Disabled') | translate }}</span>
		</div>
		@if(selectedTranscriptionLang) {
			<div [ngClass]="styles.itemRow">
				<span>{{ 'SourceLanguage' | translate }}:</span>
				<span>&nbsp;{{ selectedTranscriptionLang.name }}</span>
			</div>
		}

		@if(selectedTranslationLangs?.length) {
			<div [ngClass]="styles.itemRow">
				<span>{{ 'TranslationLanguages' | translate }}:</span>
				@for(translationLang of selectedTranslationLangs; track translationLang) {
					<span [ngClass]="styles.translationLangItem">&nbsp;{{ translationLang.name }}</span>
				}
			</div>
		}
	</div>

	@switch (webcast.videoSource) {
		@case (WebcastVideoSource.PRESENTATION) {
			<div [ngClass]="styles.itemRow">
				<span>{{ 'Event_PresentationProfile' | translate }}:</span>
				<span>&nbsp;{{ webcast.presentationProfileName }}</span>
			</div>

			<div [ngClass]="styles.itemRow">
				<span>{{ 'Event_ClosedCaptions' | translate }}:</span>
				<span>&nbsp;{{ (webcast.closedCaptionsEnabled ? 'UI_Enabled' : 'UI_Disabled') | translate }}</span>
			</div>


		}
		@case (WebcastVideoSource.SIP_ADDRESS) {
			<ng-container *ngTemplateOutlet="vciAddress"></ng-container>
		}

		@case (WebcastVideoSource.PEXIP) {
			<ng-container *ngTemplateOutlet="vciAddress"></ng-container>
		}

		@case (WebcastVideoSource.MSTEAMS) {
			<div [ngClass]="styles.itemRowVerticalCentered">
				<span class="util-nobreak">{{ 'MeetingUrl' | translate }}:</span>
				<span [ngClass]="styles.overflowHidden">&nbsp;{{ webcast.vcMicrosoftTeamsMeetingUrl }}&nbsp;</span>
				<button type="button" [attr.aria-label]="'MeetingUrl_Copy' | translate" [title]="'MeetingUrl_Copy' | translate" ngxClipboard [cbContent]="webcast.vcMicrosoftTeamsMeetingUrl" vbBtnSecondary>
					<span class="glyphicons file_import"></span>
				</button>
			</div>
		}

		@case ((webcast.videoSource === WebcastVideoSource.RTMP || webcast.videoSource === WebcastVideoSource.SRT) ? webcast.videoSource : '') {
			@if (webcast.videoSource === WebcastVideoSource.RTMP) {
				<div [ngClass]="styles.itemRow">
					<span>{{ 'Protocol' | translate }}:</span>
					<span>&nbsp;{{ (webcast.rtmpSettings.isSecure ? 'Rtmps' : 'Rtmp') | translate }}</span>
				</div>
			}
			 <div [ngClass]="styles.itemRowVerticalCentered">
				<span class="util-nobreak">{{ 'Event_Webcast_Rtmp_PushUrl' | translate }}:</span>
				<span [ngClass]="styles.overflowHidden">&nbsp;{{  mainStreamUrl }} &nbsp;</span>
				<button type="button" [attr.aria-label]="'Event_Webcast_Rtmp_PushUrlCopy' | translate" [title]="'Event_Webcast_Rtmp_PushUrlCopy' | translate" ngxClipboard [cbContent]="mainStreamUrl" vbBtnWhite>
					<span class="glyphicons file_import"></span>
				</button>
			</div>
			@if (webcast.videoSource === WebcastVideoSource.RTMP) {
				<div [ngClass]="styles.itemRowVerticalCentered">
					<span>{{ 'StreamKey' | translate }}:</span>
					<span>&nbsp;{{  webcast.rtmpSettings.streamKey }}
					</span>
					<button type="button" class="margin-left-10" [attr.aria-label]="'Event_Webcast_Rtmp_StreamCopy' | translate" [title]="'Event_Webcast_Rtmp_StreamCopy' | translate" ngxClipboard [cbContent]="webcast.rtmpSettings.streamKey" vbBtnWhite>
						<span class="glyphicons file_import"></span>
					</button>
				</div>
			}
			@if (webcast.secondarySourceEnabled && webcast.secondaryRtmpSettings) {
				<div [ngClass]="styles.itemRowVerticalCentered">
					<span class="util-nobreak">{{ 'Event_Webcast_Rtmp_PushUrl_Backup' | translate }}:</span>
					<span [ngClass]="styles.overflowHidden">&nbsp;{{  backupStreamUrl }} &nbsp;</span>
					<button type="button" [attr.aria-label]="'Event_Webcast_Rtmp_PushUrlCopy_Backup' | translate" [title]="'Event_Webcast_Rtmp_PushUrlCopy_Backup' | translate" ngxClipboard [cbContent]=" backupStreamUrl" vbBtnWhite>
						<span class="glyphicons file_import"></span>
					</button>
				</div>
				@if (webcast.videoSource === WebcastVideoSource.RTMP) {
					<div [ngClass]="styles.itemRowVerticalCentered">
						<span>{{ 'StreamKey_Backup' | translate }}:</span>
						<span>&nbsp;{{  webcast.secondaryRtmpSettings.streamKey }}
						</span>
						<button type="button" class="margin-left-10" [attr.aria-label]="'Event_Webcast_Rtmp_StreamCopy_Backup' | translate" [title]="'Event_Webcast_Rtmp_StreamCopy_Backup' | translate" ngxClipboard [cbContent]="webcast.secondaryRtmpSettings.streamKey" vbBtnWhite>
							<span class="glyphicons file_import"></span>
						</button>
					</div>
				}
				<div [ngClass]="styles.itemRow">
					<span>{{ 'CurrentStream' | translate }}:</span>
					<span>&nbsp;{{ ((WebcastViewSvc.isSecondaryPlaying$ | async) ? 'Backup' : 'Primary') | translate }}</span>
				</div>

				<button type="button" class="margin-top-10" vbBtnPrimary [disabled]="WebcastViewSvc.passiveStreamStartRecordingFailed()" (click)="onSwitchStream()">
					{{ ((WebcastViewSvc.isSecondaryPlaying$ | async) ? 'SwitchToPrimary' : 'SwitchToBackup') | translate }} ({{ ((WebcastViewSvc.isPassiveStreamReady$ | async) ? 'Streaming' : 'WaitingForStream') | translate }})
				</button>
				@if (WebcastViewSvc.passiveStreamStartRecordingFailed()) {
					<div vbUiErrorMessage class="text-center">
						{{ 'StartRecordingFailed' | translate }}
					</div>
				}

			}
		}

		@case (WebcastVideoSource.WEBEX) {
			<div [ngClass]="styles.itemRow">
				<span>{{ 'WebexTeamSpace' | translate }}:</span>
				<span>&nbsp;{{ webcast.webexTeam.name }}</span>
			</div>
		}

		@case (WebcastVideoSource.ZOOM) {
			<div [ngClass]="styles.itemRow">
				<span>{{ 'Zoom_MeetingId' | translate }}:</span>
				<span>&nbsp;{{ webcast.zoom.meetingId }}</span>
			</div>

			<div [ngClass]="styles.itemRow">
				<span>{{ 'Zoom_MeetingPassword' | translate }}:</span>
				<span>&nbsp;{{ webcast.zoom.meetingPassword || ''}}</span>
			</div>

		}

		@case (WebcastVideoSource.VOD) {
			<vb-ui-video-preview-select class="margin-bottom-10" name="vodVideoSource" [ngModel]="webcast.vodInfo" [readonly]="true">
			</vb-ui-video-preview-select>
		}
	}

	@if(isDtmfSupportedSource) {

		@if(webcast.videoSource !== WebcastVideoSource.ZOOM) {
			<div [ngClass]="styles.itemRow">
				<span>{{ 'DTMF_Pin' | translate }}:</span>
				<span>&nbsp;{{ webcast.vcSipPin || ''}}</span>
			</div>
		}

		<div [ngClass]="styles.itemRow">
			<span>{{ 'DTMF_InitialCodes' | translate }}:</span>
			<span>&nbsp;{{ webcast.vcDtmf || ''}}</span>
		</div>

		<div [ngClass]="styles.itemRow">
			<span>{{ 'DTMF_EnableControl' | translate }}:</span>
			<span>&nbsp;{{ (webcast.vcDtmfControlsEnabled ? 'UI_Enabled' : 'UI_Disabled') | translate }}</span>
		</div>
	}

	@if(isRestartEligible) {
		<button type="button" class="margin-top-10" [disabled]="isRestartDisabled$ | async" vbBtnPrimary (click)="onRestartSource()">
			{{ 'Event_VideoSource_Restart' | translate }}
		</button>
	}

</div>

<ng-template #vciAddress>
	<div [ngClass]="styles.itemRow">
		<span>{{ 'Event_Webcast_Video_Address' | translate }}:</span>
		<span>&nbsp;{{ webcast.vcSipAddress }}</span>
	</div>
</ng-template>